import { flowRight as compose } from 'lodash';
import { reduxForm } from 'redux-form';

import CreateWorkspace from './CreateWorkspace';
import formSubmit from '../../actions/formSubmit';
import { CREATE_WORKSPACE_FORM } from '../../constants/formNames';

const validation = (val) =>
  !val || (typeof val === 'object' && val.length === 0);

export default compose(
  reduxForm({
    form: CREATE_WORKSPACE_FORM,
    onSubmit: (values, dispatch) => {
      dispatch(formSubmit(CREATE_WORKSPACE_FORM));
    },
    validate: (values) => {
      return {
        name: validation(values.name),
        slug: validation(values.slug),
        defaultTimezone: validation(values.defaultTimezone),
      };
    },
  }),
)(CreateWorkspace);
